//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        items: Array
    },
    methods: {
        openPlate (id) {
            wx.navigateTo({
                url: `/packageB/plates/main?id=${id}`
            })
        }
    }
}
